import axios from 'axios'
import Vue from 'vue'
import moment from "moment"

export default {
  namespaced: true,
  state: {
    users: [],
    discussions: {},
    loading: false
  },
  mutations: {
    loading(state, value) {
      state.loading = value
    },
    SET_DISCUSSION(state, {id, data}) {
      data.forEach(function (message) {
        message.time = moment(message.time)
      })
      Vue.set(state.discussions, id, data)
    },
    APPEND_MESSAGE(state, payload) {
      const id = payload.discussion_id
      payload.time = moment(payload.time)
      const discussions = state.discussions[id]
      if (discussions) {
        // replace message if it already exists
        const idx = discussions.findIndex(m => m.id === payload.id)
        if (idx >= 0) discussions.splice(idx, 1, payload)
        else state.discussions[id].push(payload)
      } else Vue.set(state.discussions, id, [payload])
    },
    REMOVE_MESSAGE(state, {id, discussion}) {
      const discussions = state.discussions[discussion]
      if (discussion) {
        const idx = discussions.findIndex(m => m.id === id)
        if (idx >= 0) discussions.splice(idx, 1)
      }
    },
    SET_USERS(state, users) {
      state.users = users
    },
    ADD_USER(state, user) {
      state.users.unshift(user)
    }
  },
  actions: {
    fetchContacts({commit}) {
      const base = axios.defaults.baseURL.replace('/api/student', '/api')
      return axios.get('/chat-users', {baseURL: base})
        .then(({data}) => commit('SET_USERS', data))
    },
    fetchDiscussion({commit, state}, discussionId) {
      const base = axios.defaults.baseURL.replace('/api/student', '/api')
      return axios.get(`/discussion/${discussionId}/chat`, {baseURL: base})
        .then(({data}) => {
          commit('SET_DISCUSSION', {id: discussionId, data})
        })
    },
    deleteMessage({commit}, {id, discussion}) {
      const base = axios.defaults.baseURL.replace('/api/student', '/api')
      return axios.delete('/discussion/chat/' + id, {baseURL: base})
        .then(() => {
          commit('REMOVE_MESSAGE', {id, discussion})
        })
    },
    sendMessage({commit}, {id, to, data}) {
      const base = axios.defaults.baseURL.replace('/api/student', '/api')
      let discussion_id = id
      // append user id if present
      if (to) {
        data.append('to', to.id)
        if (to.discussion_id) discussion_id = to.discussion_id
      }
      // append discussion id if present
      if (discussion_id) data.append('id', discussion_id)
      return axios.post(`/discussion/chat`, data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        baseURL: base
      })
        .then(({data}) => {
          // if new user
          if (to && !to.discussion_id) {
            Vue.set(to, 'discussion_id', data.discussion_id)
            Vue.set(to, 'last_date', data.time)
            Vue.set(to, 'loaded', true)
            commit('ADD_USER', to)
          }
          commit('APPEND_MESSAGE', data)
        })
    }
  },
  getters: {
    discussions: state => state.discussions,
    users: state => state.users
  }
}
